<template>
  <div class="modal-overlay" @click.self="$emit('close')">
    <div class="modal">
      <h3>Neuen Tarifvertrag anlegen</h3>

      <div class="field">
        <label>Kopie von</label>
        <select v-model="sourceTarifvertragId">
          <option disabled value="">Bitte wählen …</option>
          <option
            v-for="tv in tarifvertraege"
            :key="tv.id"
            :value="tv.id"
          >
            {{ tv.valid_from | dateShort }} – {{ tv.valid_till | dateShort }}
          </option>
        </select>
      </div>

      <div class="field">
        <label>Gültig von</label>
        <input type="date" v-model="validFrom" />
      </div>

      <div class="field">
        <label>Gültig bis</label>
        <input type="date" v-model="validTill" />
      </div>

      <p v-if="error" class="error">{{ error }}</p>

      <div class="actions">
        <button class="btn-secondary" @click="$emit('close')" :disabled="loading">
          Abbrechen
        </button>
        <button class="btn-primary" @click="submit" :disabled="!canSubmit || loading">
          {{ loading ? 'Wird erstellt …' : 'Tarifvertrag erstellen' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CreateTarifvertragModal',
    data () {
      return {
        sourceTarifvertragId: '',
        validFrom: '',
        validTill: '',
        loading: false,
        error: null,
      }
    },
    computed: {
      tarifvertraege () {
        return this.$store.getters['tarifvertrag/getTarifvertraege']
      },
      canSubmit () {
        return this.sourceTarifvertragId !== '' && this.validFrom !== '' && this.validTill !== ''
      }
    },
    methods: {
      async submit () {
        this.error = null
        this.loading = true
        try {
          await this.$store.dispatch('tarifvertrag/copyTarifvertrag', {
            sourceTarifvertragId: this.sourceTarifvertragId,
            validFrom: this.validFrom,
            validTill: this.validTill,
          })
          this.$emit('close')
        } catch (e) {
          this.error = e.response?.status === 403
            ? 'Keine Berechtigung zum Anlegen von Tarifverträgen.'
            : 'Fehler beim Erstellen. Bitte prüfe die Eingaben und versuche es erneut.'
        } finally {
          this.loading = false
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }

  .modal {
    background: #fff;
    border-radius: 6px;
    padding: 28px 32px;
    min-width: 360px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);

    h3 {
      margin: 0 0 20px;
      font-size: 1.1rem;
    }
  }

  .field {
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;

    label {
      font-size: 0.8rem;
      color: #666;
      margin-bottom: 4px;
    }

    select,
    input[type="date"] {
      padding: 7px 10px;
      border: 1px solid #ccc;
      border-radius: 4px;
      font-size: 0.95rem;
      &:focus {
        outline: none;
        border-color: #4a90d9;
      }
    }
  }

  .error {
    color: #c0392b;
    font-size: 0.85rem;
    margin-bottom: 12px;
  }

  .actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 8px;
  }

  .btn-primary,
  .btn-secondary {
    padding: 8px 18px;
    border-radius: 4px;
    border: none;
    cursor: pointer;
    font-size: 0.9rem;
    &:disabled {
      opacity: 0.5;
      cursor: default;
    }
  }

  .btn-primary {
    background: #4a90d9;
    color: #fff;
    &:not(:disabled):hover {
      background: #357abd;
    }
  }

  .btn-secondary {
    background: #f0f0f0;
    color: #333;
    &:not(:disabled):hover {
      background: #e0e0e0;
    }
  }
</style>
